import { config } from './runtimeConfig';

export const USE_MQTT = config.REACT_APP_USE_MQTT === 'true';
export const MQTT_URL = config.REACT_APP_MQTT_URL;
export const MQTT_USERNAME = config.REACT_APP_MQTT_USERNAME;
export const MQTT_PASSWORD = config.REACT_APP_MQTT_PASSWORD;

/**
 * Builds the telemetry topic for a given device UUID
 * @param deviceUuid - The device UUID
 * @returns The MQTT topic string: drones/{deviceUuid}/telemetry
 */
export const buildTelemetryTopic = (deviceUuid: string): string => {
  return `drones/${deviceUuid}/telemetry`;
};
